<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Promotion
            </v-row>
            <v-divider />
            <div v-if="spots?.length > 0">
                <!--spots table head-->
                <v-row class="subtitle-2" no-gutters>
                    <v-col v-for="(item, i) in headers" :key="i" 
                        class="tabCell"
                        :class="item.style">
                        {{ item.title }}
                    </v-col>
                </v-row>
                <!-- spots tab -->
                <v-row v-for="spot in spots" :key="spot.id" no-gutters>
                    <v-col class="tabCell text-left">{{ spot.name }}</v-col>
                    <v-col class="tabCell text-center">{{ spot.team?.name }}</v-col>
                    <v-col class="tabCell text-center">{{ spot.trademark?.name }}</v-col>
                    <v-col class="tabCell text-center">{{ spot.quality }}</v-col>
                    <v-col class="tabCell text-center">{{ spot.objective }}</v-col>
                    <v-col class="tabCell text-center">{{ serializing(spot.channels) }}</v-col>
                    <v-col class="tabCell text-center">{{ localeNumber(spot.investments) }}</v-col> 
                    <v-col class="tabCell text-center">{{ localeNumber(spot.budget) }}</v-col>
                    <v-col class="tabCell text-center">{{ localeNumber(spot.coverage_general) }}</v-col>
                    <v-col class="tabCell text-center">{{ localeNumber(spot.coverage_targeted) }}</v-col>
                    <v-col class="tabCell text-center">
                        <v-tooltip bottom color="primary">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" text small class="text-lowercase">
                                    {{ shortName(spot.commercial_story?.text) }}
                                </v-btn>
                            </template>
                            <div class="text-center width_250">
                                {{ spot.commercial_story?.text }}
                            </div>
                        </v-tooltip>
                    </v-col>  
                    <v-col class="tabCell text-right">
                        <edit-spot :spot="spot" /> 
                        <delete-spot :spot="spot" />
                    </v-col>
                </v-row>
                </div>
                <v-row v-else class="mt-8 px-4" justify="center">
                    You haven't spots yet!
                </v-row>
        </div>
        <!--!loading-->
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>
import deleteSpot from '../../../components/admin/spots/deleteSpot.vue';
import editSpot from '../../../components/admin/spots/editSpot.vue';
import Loader from '../../../layouts/Loader.vue'
export default {
    data() {
        return {
            headers: [
					{ title: 'Spot name', style: 'text-left'},
                    { title: 'team', style: 'text-center' },
					{ title: 'Trademark', style: 'text-center'},
					{ title: 'Quality level', style: 'text-center'},
					{ title: 'Objective', style: 'text-center'},
					{ title: 'Channels', style: 'text-center' },
					{ title: 'Investments', style: 'text-center'},
					{ title: 'Budget', style: 'text-center' },
					{ title: 'General coverage (persons)', style: 'text-center' },
					{ title: 'Targeted coverage (persons)', style: 'text-center' },
					{ title: 'Commercial story', style: 'text-center' },
					{ title: 'Action', style: 'text-right'},
				],
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading;
        },
        locale() {
            return this.$store.getters.locale;
        },
        spots() {
            console.log(this.$store.getters.spots_all)
            return this.$store.getters.spots_all;
        },
        values () {
            return this.$store.getters.VALUES;
        }
    },
    methods: {
        localeNumber(num) {
            if (this.locale == 'ro-RO') {
                return num.toLocaleString('en-US')
            }
            return num.toLocaleString(this.locale)
        },
        getValue(val) {
            return this.values?.find(v => v.value == val).text;
        },
        serializing(arr) {
            return arr.join(', ');
        },
        shortName(str) {
            if (str) {
              return str.substr(0, 10) + '...';  
            }
           return ''; 
        }
    },
    components: {deleteSpot, Loader, editSpot}
}
</script>
<style>
    .width_250 {
        width: 250px;
    }
</style>